<template>    
    <div class="admin-panel" v-if="isAdmin">
        <div>
            <input v-model="firstName" placeholder="firstName">
            <input v-model="lastName" placeholder="lastName">
            <input v-model="email" placeholder="email">
            <input type="password" v-model="password" placeholder="password">
            <button @click="registerUser">Register</button>
            <div style="color:red;">{{errorMessage}}</div>
        </div>
        <table class="table is-bordered is-striped is-narrow is-hoverable is-fullwidth">
            <thead>
                <th>Registration date</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>login</th>
            </thead>
            <tbody>
                <tr v-for="user in users" :key="user.id">
                    <td>{{user.registrationDate}}</td>
                    <td>{{user.firstName}}</td>
                    <td>{{user.lastName}}</td>
                    <td>{{user.email}}</td>                    
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>

import { dataService } from '../shared/data';

export default {
    data() {
        return {
            users: [],
            isAdmin: false,
            firstName: "",
            lastName: "",
            email: "",
            password: "",
            errorMessage:"",
        }
    },
    async created () {
        this.isAdmin = dataService.isUserAdmin();
        if(this.isAdmin)
        {
            this.users = await dataService.getUsers();
        }
        else{
            this.$router.push({name:"Home"});
        }
    },
    methods: {
        async registerUser() {
            this.errorMessage = "";
            var newUser = await dataService.registerUser({firstName: this.firstName,lastName:this.lastName,email:this.email,password:this.password});
            if(newUser)
            {
                this.users.push(newUser);

                this.firstName= "";
                this.lastName= "";
                this.email= "";
                this.password= "";
            }
            else{
                this.errorMessage = "user was not registered";
            }
        }
    },
}
</script>